import Vue from 'vue'
import $ from 'jquery'
import Vuex from 'vuex'
import axios from 'axios'
import router from '@/router'
import Swal from 'sweetalert2'
import { initSparkline, skinChanger, CustomJs, SearchDiv } from "@/assets/bundles/mainscripts.bundle.js"
import imgError from '@/assets/images/user.jpg'

Vue.use(Vuex)

const Toast = Swal.mixin({
   toast: true,
   position: 'top-end',
   showConfirmButton: false,
   timer: 3500,
   timerProgressBar: true,
   didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
   }
})

const store = {
   state: {
      // urlRest: 'https://redepaulista.com.br:8444/OneWayForum/',
      urlRest: 'https://sigap.infoone.digital/OneWayForum/',
      // urlRest: 'https://redepaulista.com.br:8444/OneWayForumTeste/',
      // urlRest: 'http://localhost:8080/OneWayForum-0.0.1/',
      errorOnLoadImg: 'https://i.ibb.co/WzR5Gtn/noImage.png',
      isCarregando: false,
      isLogado: false,
      listaPermissoes: [],
      listaAlertas: [],
      dadosUsuario: null,
      tokenSessao: null,
      tema: localStorage.getItem("theme") || "light"
   },
   mutations: {
      verificarCredenciais: (state, credenciais) => {
         if (localStorage.username != undefined && localStorage.senha != undefined) {
            credenciais = {
               "usuario": localStorage.username.split(/(\w\w)/g).filter(p => !!p).map(c => String.fromCharCode(parseInt(c, 16))).join(""),
               "senha": localStorage.senha.split(/(\w\w)/g).filter(p => !!p).map(c => String.fromCharCode(parseInt(c, 16))).join("")
            };
         }

         if (credenciais == undefined) {
            return
         } else {
            state.isCarregando = true
         }

         axios({
            method: 'get',
            url: state.urlRest + 'login',
            params: {
               username: credenciais.usuario,
               senha: credenciais.senha
            }
         }).then(function (response) {
            if (response.status == 206) {
               Swal.fire({
                  icon: 'info',
                  title: 'Senha gerada para primeiro acesso',
                  text: 'Senha: ' + response.data
               });

               return;
            }

            state.dadosUsuario = response.data
            state.tokenSessao = response.data.tokenSessao
            state.isLogado = true

            if (credenciais.manterConectado != false) {
               localStorage.username = credenciais.usuario.split("").map(c => c.charCodeAt(0).toString(16).padStart(2, "0")).join("")
               localStorage.senha = credenciais.senha.split("").map(c => c.charCodeAt(0).toString(16).padStart(2, "0")).join("")
            }

            setTimeout(function () {
               skinChanger(),
                  initSparkline(),
                  CustomJs(),
                  SearchDiv(),
                  $(".page-loader-wrapper").fadeOut();
            }, 50);

            router.push('/paginaInicial')

         }).catch(function (error) {
            state.dadosUsuario = null
            state.tokenSessao = null
            state.isLogado = false
            localStorage.removeItem('username')
            localStorage.removeItem('senha')
            router.push('/')

            if (error.response != undefined) {
               if (error.response.status == 401) {
                  Toast.fire({
                     icon: 'error',
                     title: 'Credenciais incorretas!'
                  });
               } else if (error.response.status == 403) {
                  Swal.fire({
                     icon: 'error',
                     title: 'Conta bloqueada!',
                     text: 'Número de tentativas excedido.'
                  });
               } else {
                  Toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               Toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            state.isCarregando = false
         });
      },
      deslogar: state => {
         state.isLogado = false;
         state.listaPermissoes = [];
         state.listaAlertas = [];
         state.dadosUsuario = {};
         state.tokenSessao = null;

         localStorage.removeItem('username')
         localStorage.removeItem('senha')
         router.push('/')
      },
      setTema(state, tema) {
         state.tema = tema;
      },
      alternarTelaCarregamento: (state, isCarregando) => {
         state.isCarregando = isCarregando;
      },
      buscarPermissoes: state => {
         axios({
            method: 'get',
            url: state.urlRest + 'usuarios/getPermissoes'

         }).then(response => {
            state.listaPermissoes = response.data

         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  store.mutations.deslogar(state)

                  Toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  Toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               Toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         });
      },
      buscarAlertas: state => {
         if (state.isLogado) {
            axios({
               method: 'get',
               url: state.urlRest + 'processos/getAlertas'

            }).then(response => {
               state.listaAlertas = response.data

            }).catch(function (error) {
               if (error.response != undefined) {
                  if (error.response.status == 408) {
                     store.mutations.deslogar(state)

                     Toast.fire({
                        icon: 'warning',
                        title: 'Sessão expirada!'
                     });
                  } else {
                     Toast.fire({
                        icon: 'error',
                        title: 'Erro: ' + error.response.status
                     });
                  }
               } else {
                  Toast.fire({
                     icon: 'error',
                     title: error
                  });
               }
            }).finally(() => {
               setTimeout(() => {
                  store.mutations.buscarAlertas(state)
               }, 300000);
            });
         }
      }
   },
   actions: {
      imageError(_, e) {
         e.target.src = imgError
      },
      verificarCredenciais: ({ commit }, credenciais) => {
         commit('verificarCredenciais', credenciais)
      },
      alternarTelaCarregamento: ({ commit }, isCarregando) => {
         commit('alternarTelaCarregamento', isCarregando)
      },
      /* eslint-disable-next-line no-unused-vars */
      buscarCEP: ({ commit }, cep) => {
         return new Promise((resolve, reject) => {
            axios({
               method: 'get',
               url: 'https://viacep.com.br/ws/' + cep + '/json/'

            }).then(response => {
               let local = response.data;

               if (local.logradouro != null && local.bairro != null && local.localidade != null) {
                  resolve(local.logradouro + ', ' + local.bairro + ', ' + local.localidade)
               }
            }).catch(function (error) {
               reject(error.response)
            });
         })
      },
      /* eslint-disable-next-line no-unused-vars */
      buscarInicioSemana: ({ commit }, d) => {
         /* eslint-disable-next-line no-unused-vars */
         return new Promise((resolve, reject) => {
            d = new Date(d);
            let day = d.getDay()
            let diff = d.getDate() - day + (day == 0 ? -6 : 1);

            resolve(new Date(d.setDate(diff)));
         })
      },
      buscarPermissoes: context => context.commit('buscarPermissoes'),
      buscarAlertas: context => context.commit('buscarAlertas'),
      deslogar: context => context.commit('deslogar')
   },
   modules: {
   }
}

export default new Vuex.Store(store);